export const isInviewAll = (element: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement): boolean => {
  const rect = element.getBoundingClientRect();

  // rect.top > 1 は firefox対応
  return rect.top > 1 && rect.bottom < window.innerHeight;
};
